<div class="child-dropdown" (click)="$event.stopPropagation()">
  <div class="dropdown-header">
    <span>{{ 'app.components.parentAiAssistant.selectChild' | translate }}</span>
  </div>
  <div class="child-options">
    @if (showNeutralOption()) {
      <button
        type="button"
        class="child-option child-option--neutral"
        [class.active]="!selectedChildId()"
        (click)="selectNeutral.emit()"
      >
        <span class="child-avatar-option child-avatar-option--neutral">✨</span>
        <div class="child-details">
          <span class="child-name">{{ 'app.components.parentAiAssistant.selectNeutralGeneral' | translate }}</span>
        </div>
        @if (!selectedChildId()) {
          <span class="check-icon">✓</span>
        }
      </button>
    }
    @for (child of children(); track child.id) {
      <button
        type="button"
        class="child-option"
        [class.active]="selectedChildId() === child.id"
        (click)="selectChild.emit(child)"
      >
        @if (child.avatarUrl) {
          <img class="child-avatar-option" [src]="child.avatarUrl" [alt]="child.name" />
        } @else {
          <span class="child-avatar-option">{{ fallbackLabel(child) }}</span>
        }
        <div class="child-details">
          <span class="child-name">{{ child.name }}</span>
        </div>
        @if (selectedChildId() === child.id) {
          <span class="check-icon">✓</span>
        }
      </button>
    }
  </div>
</div>
